module.exports = __webpack_public_path__ + "static/img/img_02.ce23186d.png";